import { CASES_PAGES_NAMES } from '../pagesNames';
import { retailCasesPagesData } from './retailCases';
import { telecomCasesPagesData } from './telecomCases';
import { finTechCasesPagesData } from './finTechCases';
import { bettingCasesPagesData } from './bettingCases';
import { medicineCasesPagesData } from './medicineCases';
import { industryCasesPagesData } from './industryCases';
import { oilAndGasCasesPagesData } from './oilAndGasCases';
import { realEstateCasesPagesData } from './realEstateCases';

export const projectsPageBlockCasesData = [
  telecomCasesPagesData[CASES_PAGES_NAMES.telecom_4],
  industryCasesPagesData[CASES_PAGES_NAMES.industry_1],
  bettingCasesPagesData[CASES_PAGES_NAMES.betting_1],
  telecomCasesPagesData[CASES_PAGES_NAMES.telecom_2],
  finTechCasesPagesData[CASES_PAGES_NAMES.finTech_2],

  retailCasesPagesData[CASES_PAGES_NAMES.retail_1],
  oilAndGasCasesPagesData[CASES_PAGES_NAMES.oilAndGas_4],
  medicineCasesPagesData[CASES_PAGES_NAMES.medicine_2],
  telecomCasesPagesData[CASES_PAGES_NAMES.telecom_3],
  realEstateCasesPagesData[CASES_PAGES_NAMES.realEstate_1],

  retailCasesPagesData[CASES_PAGES_NAMES.retail_2],
  oilAndGasCasesPagesData[CASES_PAGES_NAMES.oilAndGas_3],
  medicineCasesPagesData[CASES_PAGES_NAMES.medicine_1],
  retailCasesPagesData[CASES_PAGES_NAMES.retail_4],
  telecomCasesPagesData[CASES_PAGES_NAMES.telecom_1],

  finTechCasesPagesData[CASES_PAGES_NAMES.finTech_1],
  retailCasesPagesData[CASES_PAGES_NAMES.retail_5],
  retailCasesPagesData[CASES_PAGES_NAMES.retail_3],
  oilAndGasCasesPagesData[CASES_PAGES_NAMES.oilAndGas_1],
  oilAndGasCasesPagesData[CASES_PAGES_NAMES.oilAndGas_2],
];
